"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RefinedContentCheckbox = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var _Checkbox = _interopRequireDefault(require("@insided/shared/uikit/Checkbox"));

var _search = require("@insided/destination/modules/Search/utils/search");

var RefinedContentCheckbox = function RefinedContentCheckbox(props) {
  var items = props.items,
      refine = props.refine,
      phrasePrefix = props.phrasePrefix;

  if (items.length === 0) {
    return null;
  }

  return (0, _preact.h)("ul", null, items.map(function (item) {
    var _extractLabel;

    return (0, _preact.h)("li", {
      key: item.label,
      className: "instant-search__filter-list-item"
    }, (0, _preact.h)("div", {
      className: (0, _classnames.default)('instant-search-filter__label-wrapper', {
        refined: item.isRefined
      })
    }, (0, _preact.h)(_Checkbox.default, {
      label: (_extractLabel = (0, _search.extractLabel)(item.label, phrasePrefix)) !== null && _extractLabel !== void 0 ? _extractLabel : item.label,
      onUpdate: function onUpdate() {
        return refine(item.value);
      },
      qaClasses: "topic-type-checkbox",
      checked: item.isRefined
    })));
  }));
};

exports.RefinedContentCheckbox = RefinedContentCheckbox;